<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-3">
        {{ 'cart'|globalTranslate }}
      </v-card-title>
      <v-card-text class="px-0">
        <p class="mx-4" v-if="getProductsFromCartCount() === 0">Votre panier est vide !</p>
        <div v-if="getProductsFromCartCount() > 0">
          <v-list-item><DateAndQtyDisplay></DateAndQtyDisplay></v-list-item>
          <CartProductListItem v-for="(cartProduct, k) in getProductsFromCart()" :key="k" :cart-product="cartProduct"
                               :number-of-days="getNumberOfDays()" :data="data"/>
          <v-divider :inset="false"></v-divider>
          <v-list-item>
            <v-list-item-title>
              <div class="d-flex align-content-center">
                <div class="font-weight-bold cart-item-label">{{ 'cart_total_shop'|globalTranslate }}</div>
                <div class="ml-auto font-weight-bold cart-item-price">{{ getTotalWithoutDiscountTtc(2) }} &euro;</div>
              </div>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <div class="d-flex align-content-center red--text">
                <div class="font-weight-bold cart-item-label">{{ 'cart_discount'|globalTranslate }}</div>
                <div class="ml-auto font-weight-bold cart-item-price"><span v-if="getDiscountPercent(0) > 0">-</span>{{ getDiscountPercent(0) }} &percnt;</div>
              </div>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <div class="d-flex white align-center" id="warrantyChoice">
                <v-checkbox
                    v-model="warranty"
                    @change="toggleWaranty"
                    :label="'cart_warranty'|globalTranslate"
                    dense
                    hide-details
                    class="my-0 py-0"
                ></v-checkbox>
                <v-btn icon @click="infoDialog = true" class="ml-1">
                  <v-icon>mdi-help-box</v-icon>
                </v-btn>
                <strong class="ml-auto font-weight-bold">{{ getWarrantyTtc(2) }} &euro;</strong>
              </div>
            </v-list-item-title>
          </v-list-item>
          <v-divider :inset="false"></v-divider>
          <v-list-item class="my-3">
            <v-list-item-title>
              <div class="d-flex align-content-center mb-2">
                <div class="font-weight-bold cart-item-label">{{ 'cart_promo_code'|globalTranslate }}</div>
                <div v-if="getSellOff()" class="red--text ml-auto font-weight-bold cart-item-price">-{{ getSellOff().percent }} &percnt;</div>
              </div>
              <SellOffForm/>
            </v-list-item-title>
          </v-list-item>
          <v-divider :inset="false"></v-divider>
          <v-list-item class="my-3">
            <v-list-item-title>
              <div class="d-flex align-content-center">
                <div class="font-weight-bold cart-item-label">{{ 'cart_total_internet'|globalTranslate }}</div>
                <div class="ml-auto font-weight-bold cart-item-price text-h6">{{ getTotalTtc(2) }} &euro;</div>
              </div>
            </v-list-item-title>
          </v-list-item>
        </div>
      </v-card-text>
      <v-card-actions class="d-sm-flex justify-space-between flex-column flex-sm-row">
        <v-btn color="primary" class="font-weight-bold cancel" @click="onCancel" outlined large>
          {{ 'continue_order'|globalTranslate }}
        </v-btn>
        <v-btn color="primary" class="font-weight-bold validate mt-5 mt-sm-0" @click="onFinish" large>
          <v-icon left>mdi-chevron-right</v-icon>
          {{ 'finish_order'|globalTranslate }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" timeout="2000" :top="true" :right="true">{{ snackbarMsg }}</v-snackbar>
    <v-dialog v-model="infoDialog" max-width="700">
      <WarrantyInfo @cancel="infoDialog = false"/>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import CartProductListItem from "@/components/CartProductListItem";
import WarrantyInfo from "@/components/WarrantyInfo";
import snackbarMixin from "@/mixins/snackbarMixin";
import SellOffForm from "@/components/SellOffForm";
import DateAndQtyDisplay from "@/components/DateAndQtyDisplay";

export default {
  name: "Cart",
  components: {SellOffForm, WarrantyInfo, CartProductListItem, DateAndQtyDisplay},
  computed: {
    ...mapGetters({
      getDiscountPercent: "cart/getDiscountPercent",
      getProductsFromCart: "cart/getProducts",
      getProductsFromCartCount: "cart/getProductsCount",
      getTotalTtc: "cart/getTotalTtc",
      getTotalWithoutDiscountTtc: "cart/getTotalWithoutDiscountTtc",
      getWarrantyTtc: "cart/getWarrantyTtc",
      getNumberOfDays: "cart/getNumberOfDays",
      getDate: "cart/getDate",
      getSellOff: "cart/getSellOff",
    }),
    ...mapState(["cart", "data"])
  },
  created() {
    if (this.cart.warranty) {
      this.warranty = true;
    }

  },
  data() {
    return {
      busy: false,
      cartDate: "",
      infoDialog: false,
      warranty: false
    };
  },
  methods: {
    emptyCart() {
      this.$store.dispatch("cart/empty");
      this.showSnackBar("Votre panier est vide !");
    },
    onCancel() {
      this.$emit("cancel");
    },
    onFinish() {
      this.$emit("finish");
    },
    toggleWaranty() {
      this.$store.dispatch("cart/toggleWarranty");
    }
  },
  mixins: [snackbarMixin]
}
</script>

<style scoped>
.cart-item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart-item-price {
  min-width: 75px;
  text-align: right;
}
</style>
